import { Button } from "@mantine/core"
import { ArrowLeftIcon } from "@phosphor-icons/react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router-dom"
import { CustodyTransferDetail } from "../../components/custody-transfers/CustodyTransferDetail"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"

/**
 * /handover/:id. Gate = ORD_DN_MNG, the code transfer-get / initiate / sender-verify check
 * (O208: the page used ORD_DN_DRAFT_LIST and then showed the raw 403 key).
 */
export function CustodyTransferDetailPage() {
  const { t } = useTranslation(["delivery", "common"])
  const ORD_DN_MNG = usePermission("ORD_DN_MNG")
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  return (
    <PageLayout
      title={t("custody.detailPageTitle")}
      subTitle={t("custody.pageSubtitle")}
      breadcrumb={[
        { to: "/", label: t("common:breadcrumb.home") },
        { to: "/supplier-delivery?tab=HANDOVER", label: t("delivery:breadcrumb.deliveryManagement") },
        { to: "/supplier-delivery?tab=HANDOVER", label: t("delivery:custody.breadcrumb") },
        { label: t("delivery:custody.card.detail") },
      ]}
      extra={[
        <Button key="back" variant="default" leftSection={<ArrowLeftIcon size={16} />} onClick={() => navigate(-1)}>
          {t("custody.back")}
        </Button>,
      ]}
    >
      {!id ? null : ORD_DN_MNG.hasAccess ? <CustodyTransferDetail transferId={id} /> : ORD_DN_MNG.accessDenied()}
    </PageLayout>
  )
}
